import { render, staticRenderFns } from "./MaintenanceTemplatesList.vue?vue&type=template&id=fd5452ac&scoped=true"
import script from "./MaintenanceTemplatesList.ts?vue&type=script&lang=ts&external"
export * from "./MaintenanceTemplatesList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5452ac",
  null
  
)

export default component.exports